module.exports = __webpack_public_path__ + "img/rope-cleaning-genting-hotel.ef67a3c7.jpg";